import type { TrackWithDetails } from '../types'

const DEFAULT_PAGE_SIZE = 200

export function shuffleTracks<T>(tracks: T[]): T[] {
  const shuffled = [...tracks]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}

export async function fetchAllTrackPages(
  fetchPage: (limit: number, offset: number) => Promise<TrackWithDetails[]>,
  totalCount?: number,
  pageSize = DEFAULT_PAGE_SIZE
): Promise<TrackWithDetails[]> {
  const allTracks: TrackWithDetails[] = []
  let offset = 0

  while (true) {
    const page = await fetchPage(pageSize, offset)
    allTracks.push(...page)

    if (page.length < pageSize) break
    if (totalCount && allTracks.length >= totalCount) break

    offset += page.length
  }

  return totalCount ? allTracks.slice(0, totalCount) : allTracks
}
